import { render, staticRenderFns } from "./DettaglioPrenotazioneEvento.vue?vue&type=template&id=fa38fd4c&"
import script from "./DettaglioPrenotazioneEvento.vue?vue&type=script&lang=js&"
export * from "./DettaglioPrenotazioneEvento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports